/* eslint-disable react/require-default-props */
/* eslint-disable no-nested-ternary */
import {
  FindManyCityDocument,
  FindManyCountryDocument,
  FindManyStateDocument,
  FindUniqueCityDocument,
} from '@/types/graphql/types'
import { useQuery } from '@apollo/client'
import { Select } from '@mantine/core'
import { useForm } from '@mantine/form'
import { isArray, isNaN, isNumber, parseInt, toString } from 'lodash'
import useTranslation from 'next-translate/useTranslation'
import InfinityLoader from './infinityLoader'

// default to
const saudiArabiaId = '194'

const SelectCity = ({
  onSelect,
  cityId,
  required = true,
}: {
  onSelect: (cityId: string) => void
  cityId?: number
  required?: boolean
}) => {
  const form = useForm({
    initialValues: {
      countryId: (cityId ? null : saudiArabiaId) as string | null,
      stateId: null as string | null,
      cityId: null as string | null,
    },
  })

  const { loading } = useQuery(FindUniqueCityDocument, {
    variables: {
      where: {
        id: cityId,
      },
    },
    onCompleted: data => {
      if (data.findUniqueCity) {
        form.setValues({
          stateId: toString(data.findUniqueCity.stateId),
          countryId: toString(data.findUniqueCity.countryId),
          cityId: toString(cityId),
        } as any)
      }
    },

    skip: !cityId,
  })

  const countryId = isNaN(parseInt(form.values.countryId ?? ''))
    ? null
    : parseInt(form.values.countryId ?? '')

  const stateId = isNaN(parseInt(form.values.stateId ?? ''))
    ? null
    : parseInt(form.values.stateId ?? '')

  const { data: countryData, loading: countryLoading } = useQuery(
    FindManyCountryDocument,
  )

  const { loading: stateLoading, data: stateData } = useQuery(
    FindManyStateDocument,
    {
      skip: !countryId,
      variables: { where: { countryId: { equals: countryId } } },
    },
  )
  const { loading: cityLoading, data: cityData } = useQuery(
    FindManyCityDocument,
    { skip: !stateId, variables: { where: { stateId: { equals: stateId } } } },
  )

  const { t } = useTranslation('common')

  if (loading) return <InfinityLoader />
  return (
    <>
      {countryLoading ? (
        <InfinityLoader variant="sm" />
      ) : (
        <Select
          required={required}
          {...form.getInputProps('countryId')}
          onChange={e => {
            form.setValues({ countryId: e, stateId: null, cityId: null })
          }}
          label={t('country')}
          searchable
          data={
            countryData?.findManyCountry?.map(c => ({
              value: toString(c.id || '-'),
              label: c.name || '-',
            })) || []
          }
        />
      )}
      {!isNumber(countryId) ? null : stateLoading &&
        isArray(stateData?.findManyState) ? (
        <InfinityLoader variant="sm" />
      ) : (
        <>
          <Select
            required={required}
            {...form.getInputProps('stateId')}
            onChange={e => {
              form.setValues({ ...form.values, stateId: e, cityId: null })
            }}
            label={t('state')}
            searchable
            data={
              stateData?.findManyState?.map(c => ({
                value: toString(c.id || '-'),
                label: c.name || '-',
              })) || []
            }
          />

          {!isNumber(stateId) ? null : cityLoading &&
            isArray(cityData?.findManyCity) ? (
            <InfinityLoader variant="sm" />
          ) : (
            <Select
              required={required}
              {...form.getInputProps('cityId')}
              onChange={e => {
                onSelect(e!)
                form.getInputProps('cityId').onChange(e)
              }}
              label={t('city')}
              searchable
              data={
                cityData?.findManyCity?.map(c => ({
                  value: toString(c.id || '-'),
                  label: c.name || '-',
                })) || []
              }
            />
          )}
        </>
      )}
    </>
  )
}

export default SelectCity
